import { render, staticRenderFns } from "./OverallOld.vue?vue&type=template&id=9f1ebac0&scoped=true"
import script from "./OverallOld.vue?vue&type=script&lang=js"
export * from "./OverallOld.vue?vue&type=script&lang=js"
import style0 from "./OverallOld.vue?vue&type=style&index=0&id=9f1ebac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1ebac0",
  null
  
)

export default component.exports